import { makeStyles } from '@policygenius/mortar';

export default makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    [`@media (min-width: ${theme.breakpoints.medium}px)`]: {
      padding: [60, 48, 120],
    },
  },
  options: {
    width: '100%',
    border: 'none',
    [`@media (min-width: ${theme.breakpoints.medium}px)`]: {
      maxWidth: '564px',
    },
  },
  heading: {
    textAlign: 'center',
    margin: [0, 'auto', theme.spacing('xxlarge')],
    [`@media (min-width: ${theme.breakpoints.medium}px)`]: {
      maxWidth: '640px',
    },
  },
  subHeading: {
    marginTop: theme.spacing('medium'),
    textAlign: 'center',
  },
  radio: {
    position: 'relative',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${theme.colors.gray300}`,
    transition: 'background-color .25s, box-shadow .25s',
  },
  radioSelected: {
    background: theme.colors.white,
    borderColor: theme.colors.blue400,
  },
  input: {
    position: 'absolute',
    left: theme.spacing('large'),
    margin: 0,
    opacity: 0,
    '& + label': {
      cursor: 'pointer',
      margin: 0,
      width: '100%',
      height: '100%',
      padding: [theme.spacing('medium'), 0],
      display: 'flex',
      alignItems: 'center',
      '&:before': {
        content: '""',
        background: theme.colors.gray100,
        borderRadius: '100%',
        border: `1px solid ${theme.colors.gray300}`,
        display: 'inline-block',
        width: theme.spacing('large'),
        height: theme.spacing('large'),
        position: 'relative',
        margin: [0, theme.spacing('medium'), 0, theme.spacing('medium')],
        verticalAlign: 'top',
        textAlign: 'center',
      },
    },
    '&:checked': {
      '& + label': {
        '&:before': {
          backgroundColor: theme.colors.orange400,
          boxShadow: `inset 0 0 0 2px ${theme.colors.gray100}`,
        },
      },
    },
    '&:focus': {
      '& + label': {
        '&:before': {
          boxShadow: `inset 0 0 0 2px ${theme.colors.gray100}`,
        },
      },
    },
  },
  continueButton: {
    width: '90%',
    marginTop: theme.spacing('large'),
    [`@media (min-width: ${theme.breakpoints.medium}px)`]: {
      maxWidth: '564px',
    },
  },
}));
